(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  let photoObserver;
  const movingPhotos = new Set();
  const reveal = root => {
    root.querySelectorAll('.cm-page-grid,.cm-rich-grid,.cm-business-capabilities').forEach(group => {
      [...group.children].forEach((card, index) => {
        card.setAttribute('data-reveal', '');
        card.style.setProperty('--cm-reveal-delay', `${Math.min(index % 3, 2) * 65}ms`);
      });
    });
    const elements = [...root.querySelectorAll('[data-reveal]')];
    if (reduced.matches || !('IntersectionObserver' in window)) {
      elements.forEach(element => element.classList.add('is-visible'));
      return;
    }
    observer ??= new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {threshold: .08, rootMargin: '0px 0px 30px 0px'});
    document.documentElement.classList.add('cm-motion-ready');
    elements.forEach(element => {
      const rect = element.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) element.classList.add('is-visible');
      else observer.observe(element);
    });
  };
  let requested = false;
  const updateHero = () => {
    requested = false;
    if (reduced.matches || document.hidden) return;
    movingPhotos.forEach(photo => {
      if (!photo.isConnected) {movingPhotos.delete(photo); return;}
      const rect = photo.getBoundingClientRect();
      const travel = Math.max(-1, Math.min(1, (window.innerHeight / 2 - rect.top - rect.height / 2) / window.innerHeight));
      photo.style.setProperty('--cm-photo-offset', `${(travel * 22).toFixed(2)}px`);
    });
    const hero = document.querySelector('[data-hero-motion]');
    if (!hero || reduced.matches || document.hidden) return;
    const rect = hero.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight) return;
    const progress = Math.min(1, Math.max(0, -rect.top / rect.height));
    hero.style.setProperty('--cm-hero-progress', progress.toFixed(3));
  };
  const schedule = () => { if (reduced.matches || document.hidden || (!movingPhotos.size && !document.querySelector('[data-hero-motion]'))) return; if (!requested) { requested = true; requestAnimationFrame(updateHero); } };
  const init = (root = document) => {
    reveal(root);
    if (!reduced.matches && 'IntersectionObserver' in window) {
      photoObserver ??= new IntersectionObserver(entries => {
        entries.forEach(entry => entry.isIntersecting ? movingPhotos.add(entry.target) : movingPhotos.delete(entry.target));
        schedule();
      });
      root.querySelectorAll('[data-cm-photo-motion]').forEach(photo => photoObserver.observe(photo));
    }
    root.querySelectorAll('.cm-nav-menu').forEach(menu => {
      if (menu.dataset.bound) return;
      menu.dataset.bound = 'true';
      menu.addEventListener('toggle', () => {
        if (menu.open) document.querySelectorAll('.cm-nav-menu[open]').forEach(other => { if (other !== menu) other.open = false; });
      });
    });
    schedule();
  };
  document.addEventListener('click', event => {
    if (!event.target.closest('.cm-nav-menu')) document.querySelectorAll('.cm-nav-menu[open]').forEach(menu => menu.open = false);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.cm-nav-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  reduced.addEventListener('change', () => {
    observer?.disconnect();
    photoObserver?.disconnect();
    photoObserver = null;
    movingPhotos.clear();
    document.querySelectorAll('[data-cm-photo-motion]').forEach(photo => photo.style.removeProperty('--cm-photo-offset'));
    observer = null;
    document.documentElement.classList.remove('cm-motion-ready');
    init();
  });
  document.addEventListener('focusin', event => {
    let reveal = event.target.closest('[data-reveal]');
    while (reveal) {reveal.classList.add('is-visible'); reveal = reveal.parentElement?.closest('[data-reveal]');}
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
